module.exports = {
  lang: "한국어",
  webwallet_mobile_app: "APP",
  webwallet_your: "EVM 월렛",
  webwallet_wallet: "지갑",
  webwallet_home_des: "EVM 토큰의  발송, 요청 및 스왑이 가능합니다.",
  webwallet_login: "Browser Extension으로 로그인",
  webwallet_copy_address: "주소 복사",
  webwallet_qr_code: "QR코드",
  webwallet_estimated_value: "Estimated Value",
  webwallet_total: "Total",
  webwallet_refresh: "Refresh",
  webwallet_logout: "Logout",
  webwallet_transactions: "거래 기록",
  webwallet_erc20_transactions: "Erc20 토큰 거래",
  webwallet_to_address: "접수 주소",
  webwallet_to_address_pl: "지갑 주소 입력",
  webwallet_cheap: "Cheap",
  webwallet_fast: "Fast",
  webwallet_simple: "기분 설치",
  webwallet_advanced: "고급 설치",
  webwallet_memo_pl: "최대한 30개자(필수 아님)",
  webwallet_fee: "수수료",
  webwallet_txHash: "거래 번호",
  webwallet_type: "종류",
  webwallet_value: "수량",
  webwallet_status: "거래 상태",
  webwallet_block_height: "Block Height",
  webwallet_tx_time: "거래 시간",
  transaction_information: "거래 내역",
  webwallet_refresh_balance: '잔액을 새로 고침 하다',
  available: "Available",
  delegate: "Delegated",
  undelegate: "Undelegating",
  transfer: "이체",
  transfer_amount: "이체 금액",
  memo: "비고",
  noTransaction: "거래 기록이 없습니다",
  noMathExtension: "Math Wallet 브라우저를 접속하세요",
  from: "발송자",
  to: "접수자",
  transfer_account_null: "입금 주소를 입력하세요",
  transfer_amount_null: "금액을 입력하세요",
  copy_success: "복사 완료",
  copy_fail: "복사하세요",
  transfer_success: "이체 완료",
  transfer_fail: "이체 실패",
  transfer_amount_min: "이체 금액이 최소한 ",
  back_transactions: "거래 기록으로 돌아가기",
  gas_limit: "Gas Limit",
  gas_used: "Gas Used",
  gas_price: 'Gas Price',
  contract: "컨트랙트",
  mathExtensionLock: "Math Wallet unlock",
  TRC20_transfer: "TRC20 이체",
  check_account: '선택된 계정과 현재 계정이 일치하지 않음',
  gas_price_min: 'Gas Price 최소한 1Gwei',
  gas_limit_min: 'Gas Limit 최소한',
  prompt: 'Prompt',
  input_data: '데이터 입력',
  transfer_input: '16진수 데이터 입력(필수 아님)',
  locked: 'Locked',
  submit_success: '제출 완료',
  gas_limit_null: 'Gas Limit is null',
  gas_Price_null: 'Gas Price is null',
  webwallet_amount_notenough: ' 잔액이 부족합니다',
  node_not_available:'유효하지 않은 노드',
  webwallet_extrinsicID: '거래ID',
  webwallet_module: '모듈',
  webwallet_signature: '사인',
  webwallet_address: '주소',
  webwallet_transfers: '이체 기록',
  noTransfer: '이체 기록이 없습니다',
  Confirm:'Confirm',
  confirmed: 'Confirmed',
  unconfirmed: 'Unconfirmed',
  confirmations: 'Confirmations',
  transferring: 'Signing...',
  transfer_same_account: 'Cannot transfer tokens to the same account',
  ledger_login: 'Ledger로 로그인',
  add: 'Add',
  receive_tips:'This address can only be used to receive %w. Do not send other tokens to this address.',
  receive: 'Receive',
  noAdded: 'No tokens to add',
  token_add_successful: 'Successfully',
  token_add_fail: 'Failed',
  switch_to: 'Please switch the extension to %w',
  please_create_account: 'Please create your account',
  webwallet_to_valid_address: 'Please enter valid recipient address',
  ledger_lock: "Please unlock your Ledger Wallet",
  blockchain_explorer: 'Blockchain Explorer',
  add_custom_token: 'Add Custom Token',
  token_address: 'Address',
  token_decimals: 'Decimals',
  token_symbol: 'Symbol',
  cancel_btn: 'Cancel',
  invalid_address: 'Invalid Address',
  token_exist: 'The token already exists',
  collectibles: 'Collectibles',
  assets: 'Assets',
  add_customNFTs: 'Add Custom NFTs',
  send: 'Send',
  no_information: 'No Information',
  pending: 'Pending...',
  connect_currentWallet: 'Please logout and connect to your current wallet',
  nft_transfer_success: 'Sent successfully. Collectibles list may take up to 24 hours to sync.',
  not_nft_owner: 'This NFT has already been transferred. Collectibles list will update as soon as the sync is complete.',
  NFTUpdateNotice: "NFT Update Notice",
  NFTUpdateNoticeInfo: "Collectibles list may take up to 24 hours to refresh due to data synchronization from new transactions and NFT additions. <br><br>If you continue to experience issues, please email us at <a class='text-blue' href='mailto:hello@mathwallet.org'>hello@mathwallet.org</a>, and we will get back to you as soon as possible.",
}
